import { Meteor } from 'meteor/meteor'
import { CodePromo } from '../components/CodeTyper'

import { SET_OFFERS } from '../reducers/offers'
import { dispatch } from '../store'

const fetchOffers = async () => {
  const listOffers = await Meteor.promise('getOffers', { code: CodePromo.get() })

  dispatch({
    type: SET_OFFERS,
    payload: listOffers,
  })
}

export { fetchOffers }
